import {RichTextConstants} from "@ispm/shared/classes/RichTextConstants";
import {isEmpty} from "lodash";

/** Utility file for rich text */

export class RichTextUtils {

  public static containsHeading(richText: string): boolean {
    const matchH1 = richText.match(RichTextConstants.H1Regex) !== null;
    const matchH2 = richText.match(RichTextConstants.H2Regex) !== null;
    return matchH1 || matchH2;
  }

  public static stripTags(richText: string): string {
    if (richText) {
      return richText.replace(RichTextConstants.HTMLTagsRegex, ' ');
    } else {
      return '';
    }
  }

  public static textIsOnlyOneLine(richText: string): boolean {
    const lines = richText.match(RichTextConstants.LinesRegex);
    const listItem = richText.match(RichTextConstants.ListItemRegex);

    if (lines && lines.length === 1) {
      if (listItem && listItem.length > 0) { //check if there any listItem
        if (listItem.length === 1) {
          return true;
        } else {
          return false;
        }
      } else { //no list item, only sentence
        return true;
      }
    } else { //there is no sentence only list
      if (listItem && listItem.length === 1) {
        return true;
      }
    }
  }

  public static richTextIsHTML(richText: string): boolean {
    return RichTextConstants.HTMLRegex.test(richText);
  }

  /**
   * convert text to <p>text</p>,
   * convert newline to <p><br></p>
   *
   */
  public static convertTextToHTML(richText: string): string {
    let convertedHTML = '';
    richText = richText.replace(RichTextConstants.NewLineRegex, RichTextConstants.NewLine);
    const indexOfNewLine = richText.indexOf(RichTextConstants.NewLine);
    if (indexOfNewLine === -1) {
      return this.createParagraph(richText);
    }
    while (richText.indexOf(RichTextConstants.NewLine) !== -1) {
      const indexOfNewLine = richText.indexOf(RichTextConstants.NewLine);
      const firstLine = indexOfNewLine !== 0 ? this.createParagraph(richText.substring(0, indexOfNewLine)) : this.createParagraph(richText.substring(0, 4));
      convertedHTML = convertedHTML + firstLine;
      richText = indexOfNewLine !== 0 ? richText.substring(indexOfNewLine, richText.length) : richText.substring(4, richText.length);
    }
    return isEmpty(richText) ? convertedHTML : convertedHTML + this.createParagraph(richText);
  }

  public static createParagraph(richText: string): string {
    return RichTextConstants.P + richText + RichTextConstants.ClosingP;
  }

  public static getFirstSentence(richText: string): string {
    if (this.textIsOnlyOneLine(richText)) {
      return richText
    } else {
      return this.getFirstSentenceFromMultipleLines(richText);
    }
  }

  public static getSubStringTillIndex(richText: string, indexOfEndOfSentence: number): string {
    return richText.substring(0, indexOfEndOfSentence);


  }

  public static getFirstSentenceFromMultipleLines(richText: string): string {
    const lines = richText.match(RichTextConstants.LinesRegex);
    const listItem = richText.match(RichTextConstants.ListItemRegex);
    const indexOfP = richText.indexOf(RichTextConstants.P);
    const indexOfClosingP = richText.indexOf(RichTextConstants.ClosingP);
    const indexOfList = richText.indexOf(RichTextConstants.List);
    const indexOfOrderedList = richText.indexOf(RichTextConstants.OrderedList);
    const indexOfClosingListItem = richText.indexOf(RichTextConstants.ClosingListItem);

    let firstSentence, ellipsis;
    if (lines) {
      if (listItem) {
        if (indexOfList !== -1 && indexOfList < indexOfP) {
          ellipsis = RichTextConstants.EllipsisForList;
        } else {
          if (indexOfOrderedList !== -1 && indexOfOrderedList < indexOfP) {
            ellipsis = RichTextConstants.EllipsisForOrderedList;
          }
        }
        firstSentence = this.getSubStringTillIndex(richText, indexOfClosingListItem) + ellipsis;
      } else {
        firstSentence = richText.substring(0, indexOfClosingP + 4) + RichTextConstants.EllipsisForP;
      }

    } else {
      if (listItem) {
        if (indexOfList !== -1 && indexOfOrderedList === -1 || (indexOfList !== -1 && indexOfOrderedList !== -1 && indexOfList < indexOfOrderedList)) {
          ellipsis = RichTextConstants.EllipsisForList;
        } else {
          if ((indexOfOrderedList !== -1 && indexOfList === -1) || (indexOfList !== -1 && indexOfOrderedList !== -1 && indexOfOrderedList < indexOfList)) {
            ellipsis = RichTextConstants.EllipsisForOrderedList;
          }
        }
        firstSentence = this.getSubStringTillIndex(richText, indexOfClosingListItem) + ellipsis;

      }
    }
    return firstSentence;
  }

  public static isWhitespace(word: string) {
    let whiteSpace = false
    if ((word == ' ') || (word == '\t') || (word == '\n')) {
      whiteSpace = true;
    }
    return whiteSpace;
  }

  public static escapeChevron(val: string): string {
    const lessThen: string = '&lt;';

    if (typeof(val) === 'string' && val.trim() !== '') {
      // start from the begining of the string
      let posLt = val.indexOf('<');
      while (posLt !== -1) {
        if (posLt > -1) {
          const posGt = val.indexOf('>', posLt);
          const posLt_1 = val.indexOf('<', posLt + 1);
          if (posLt_1 !== -1 && posLt_1 < posGt) {
            // here we check nested item if string has nested text inside chevrons, like "abc <d <ef> gh> ij" - <ef> is nested item
            val = val.substring(0, posLt_1) + lessThen + val.substring(posLt_1 + 1);
            continue;
          }
          let tag = val.slice(posLt + 1, posGt);

          const posSpaceInTag = tag.indexOf(' ');
          if (posSpaceInTag !== -1) {
            // the tag has attributes, remove them to get just the tag itself: <img src ='...'> --> img
            tag = tag.substring(0, posSpaceInTag);
          }

          // there are 3 rich text tags without closing tag, see
          // http://web.mit.edu/xavid/arch/i386_rhel4/help/319.htm#:~:text=Rich%20Text%20is%20a%20subset,first%20line%20contains%20a%20tag,
          // so we are checking for these tags, for other - looking for the suitable closing tag
          if (!((tag.indexOf('/') === 0) || ['br', 'hr', 'img'].includes(tag) || val.includes('</' + tag + '>', posGt))) {
            // some text inside the angle brackets, not a rich text tag, escape it
            const newTag = ('<' + tag).replace(/</, lessThen);
            const arr = val.split('<' + tag);
            val = arr[0] + newTag + arr[1];
            posLt = val.indexOf('<', posLt + lessThen.length);
          } else {
            posLt = val.indexOf('<', posLt + tag.length);
          }
        }
      }
    }

    return val;
  }
}
